function AutoBind(originalMethod, {
  name,
  addInitializer
}) {
  addInitializer(function () {
    this[name] = originalMethod.bind(this);
  });
}

export { AutoBind };